import { c as _c } from "react/compiler-runtime";
import type { ConvictionChartSnapshotInput } from '@morfi/backend-sdk-v2/client';
import { useLayoutEffect } from 'react';

/** SSR is a one-time preview; pending refinements retain the last painted SDK geometry. */
export function useConvictionOpeningSnapshot(data, opening, retireOpening) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== data || $[1] !== retireOpening) {
    t0 = () => {
      if (data != null) {
        retireOpening();
      }
    };
    t1 = [data, retireOpening];
    $[0] = data;
    $[1] = retireOpening;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useLayoutEffect(t0, t1);
  return data ?? opening;
}